import { render } from "./CloseReasonsManagement.vue?vue&type=template&id=5ec1f806&scoped=true"
import script from "./CloseReasonsManagement.vue?vue&type=script&lang=js"
export * from "./CloseReasonsManagement.vue?vue&type=script&lang=js"

import "./CloseReasonsManagement.vue?vue&type=style&index=0&id=5ec1f806&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec1f806"]])

export default __exports__